module.exports = __webpack_public_path__ + "img/Logo-16.9e90cdfb.svg";